export default __webpack_public_path__ + "static/media/logo.6a242cf3.svg";